import React from 'react';
import { cn } from '../../utils/cn';

const badgeVariants = {
    base: 'inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none transition-colors overflow-hidden',
    variants: {
        variant: {
            default: 'border-transparent bg-primary-600 text-white',
            secondary: 'border-transparent bg-slate-100 text-slate-900',
            destructive: 'border-transparent bg-red-600 text-white',
            outline: 'text-slate-900 border-slate-200 hover:bg-slate-100',
        },
    },
};

export function Badge({ className, variant = 'default', ...props }) {
    const variantClasses = badgeVariants.variants.variant[variant] || badgeVariants.variants.variant.default;

    return <span className={cn(badgeVariants.base, variantClasses, className)} {...props} />;
}
